<p-dialog
    header="Correct Bill-to Party"
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(1120px, 94vw)' }"
    [breakpoints]="{ '860px': '96vw' }"
    [closable]="!saving"
    styleClass="master-create-dialog">
    <section class="master-dialog-body">
        <aside class="master-dialog-summary">
            <div class="summary-icon"><i class="pi pi-building"></i></div>
            <div>
                <small>Shipment bill-to party</small>
                <h3>{{ shipment?.shipmentNumber }}</h3>
                <p>Correct the commercial party before posting to Accounts. Delivery work and evidence stay with this shipment.</p>
            </div>
            <div class="master-dialog-facts">
                <div><span>Current client</span><strong>{{ shipment?.crmClientName || 'No CRM client' }}</strong></div>
                <div><span>Account</span><strong>{{ shipment?.crmAccountName || 'None' }}</strong></div>
                <div><span>Contact</span><strong>{{ shipment?.crmClientContactName || 'None' }}</strong></div>
            </div>
        </aside>

        <div class="master-dialog-form party-correction-form">
            <app-commercial-party-picker *ngIf="visible && shipment?.owningCompany?.id"
                class="master-wide-field"
                [owningCompanyId]="shipment!.owningCompany.id" [value]="target" [allowLegacy]="false"
                [required]="true" label="Replacement bill-to party" (valueChange)="onPartyChange($event)">
            </app-commercial-party-picker>

            <section class="commercial-review master-wide-field" aria-labelledby="commercial-review-title">
                <h4 id="commercial-review-title">Review existing commercial terms</h4>
                <p>These values will stay on the shipment after the party changes.</p>
                <div class="commercial-review-facts">
                    <div><span>Selling price</span><strong>{{ shipment?.sellingPrice == null ? 'Not set' : (shipment?.sellingPrice | number:'1.2-2') + ' ' + (shipment?.currencyCode || '') }}</strong></div>
                    <div><span>Charge lines</span><strong>{{ shipment?.chargeLines?.length || 0 }}</strong></div>
                    <div><span>Current payment term</span><strong>{{ shipment?.paymentTerm?.name || 'Not set' }}</strong></div>
                    <div><span>New client's default term</span><strong>{{ defaultPaymentTermLabel }}</strong></div>
                </div>
                <label class="commercial-review-confirm" for="party-commercial-review">
                    <p-checkbox inputId="party-commercial-review" [(ngModel)]="reviewed" [binary]="true"></p-checkbox>
                    <span>I reviewed the prices, charges, and payment term and will preserve them.</span>
                </label>
            </section>

            <p-inputGroup class="master-wide-field">
                <p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <textarea id="party-correction-reason" pTextarea [(ngModel)]="reason" rows="3" maxlength="1000"
                        placeholder="Explain why the original bill-to party was incorrect"></textarea>
                    <label for="party-correction-reason">Reason for correction *</label>
                </p-iftalabel>
            </p-inputGroup>
            <small *ngIf="error" class="p-error master-wide-field save-error" role="alert">{{ error }}</small>
        </div>
    </section>

    <ng-template pTemplate="footer">
        <div class="master-dialog-footer">
            <span class="footer-spacer"></span>
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
                [disabled]="saving" (onClick)="visible = false"></p-button>
            <p-button label="Save correction" icon="pi pi-save" [loading]="saving" [disabled]="!canSave"
                (onClick)="save()"></p-button>
        </div>
    </ng-template>
</p-dialog>
